import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import type { AddressResponse } from '~/types/global'
import { fetchApiWithToken } from '../utils'

export interface AgencyResponse {
  id: number
  name: string
  address?: AddressResponse
}

export const useAgency = (
  agencyId: number | null | undefined
): UseQueryResult<AgencyResponse, Error> =>
  useQuery({
    queryKey: ['agency', agencyId],
    queryFn: () =>
      fetchApiWithToken({
        method: 'get',
        url: `/v1/agencies/${agencyId}`
      }),
    enabled: agencyId !== null && agencyId !== undefined,
    staleTime: 1800_000,
    refetchOnWindowFocus: false
  })
